class ChannelTalkService {
  constructor() {
    this.isInitialized = false;
    this.isBooted = false;
    this.currentUser = null;
  }

  // SDK初期化
  initialize() {
    if (this.isInitialized) return;

    try {
      // 直接スクリプト方式でSDKを読み込み
      (function () {
        var w = window;
        if (w.ChannelIO) {
          return w.console.error('ChannelIO script included twice.');
        }
        var ch = function () {
          ch.c(arguments);
        };
        ch.q = [];
        ch.c = function (args) {
          ch.q.push(args);
        };
        w.ChannelIO = ch;
        function l() {
          if (w.ChannelIOInitialized) {
            return;
          }
          w.ChannelIOInitialized = true;
          var s = document.createElement('script');
          s.type = 'text/javascript';
          s.async = true;
          s.src = 'https://cdn.channel.io/plugin/ch-plugin-web.js';
          var x = document.getElementsByTagName('script')[0];
          if (x.parentNode) {
            x.parentNode.insertBefore(s, x);
          }
        }
        if (document.readyState === 'complete') {
          l();
        } else {
          w.addEventListener('DOMContentLoaded', l);
          w.addEventListener('load', l);
        }
      })();

      this.isInitialized = true;
      console.log('ChannelTalk SDK initialized');
    } catch (error) {
      console.error('ChannelTalk SDK initialization failed:', error);
    }
  }

  // 匿名ユーザー用ブート
  bootAnonymous() {
    try {
      this.initialize();

      if (this.isBooted) {
        this.shutdown();
      }

      window.ChannelIO('boot', {
        'pluginKey':
          process.env.REACT_APP_CT_PLUGIN_KEY || 'your_plugin_key_here',
      });

      this.isBooted = true;
      this.currentUser = null;
      console.log('ChannelTalk booted for anonymous user');
    } catch (error) {
      console.error('ChannelTalk anonymous boot failed:', error);
    }
  }

  // 会員ユーザー用ブート
  bootMember(userProfile) {
    try {
      this.initialize();

      if (this.isBooted) {
        this.shutdown();
      }

      const profile = {
        'name':
          `${userProfile.last_name || ''} ${userProfile.first_name || ''}`.trim(),
        'email': userProfile.email || '',
        'mobileNumber': userProfile.custom_field1 || '',
        'customField1': userProfile.company_name || '',
        'customField2': userProfile.plan?.name || 'free',
        'customField3': userProfile.role || 'user',
        // customField4: ticket_count は廃止（クレジット制に移行）
        'customField5': userProfile.fact_check_access ? 'true' : 'false',
      };

      window.ChannelIO('boot', {
        'pluginKey':
          process.env.REACT_APP_CT_PLUGIN_KEY || 'your_plugin_key_here',
        'memberId': userProfile.user_id,
        'profile': profile,
      });

      this.isBooted = true;
      this.currentUser = userProfile;
      console.log('ChannelTalk booted for member user:', userProfile.user_id);
    } catch (error) {
      console.error('ChannelTalk member boot failed:', error);
    }
  }

  // ユーザー情報更新
  updateUser(userProfile) {
    try {
      if (!this.isBooted) return;

      const profile = {
        'name':
          `${userProfile.last_name || ''} ${userProfile.first_name || ''}`.trim(),
        'email': userProfile.email || '',
        'mobileNumber': userProfile.custom_field1 || '',
        'customField1': userProfile.company_name || '',
        'customField2': userProfile.plan?.name || 'free',
        'customField3': userProfile.role || 'user',
        // customField4: ticket_count は廃止（クレジット制に移行）
        'customField5': userProfile.fact_check_access ? 'true' : 'false',
      };

      window.ChannelIO('updateUser', profile);
      this.currentUser = userProfile;
      console.log('ChannelTalk user updated:', userProfile.user_id);
    } catch (error) {
      console.error('ChannelTalk user update failed:', error);
    }
  }

  // イベントトラッキング
  trackEvent(eventName, properties = {}) {
    try {
      if (!this.isBooted) return;

      // 基本プロパティを追加
      const enhancedProperties = {
        ...properties,
        timestamp: new Date().toISOString(),
        user_id: this.currentUser?.user_id || 'anonymous',
        plan: this.currentUser?.plan?.name || 'free',
        role: this.currentUser?.role || 'user',
      };

      window.ChannelIO('track', eventName, enhancedProperties);
      console.log('ChannelTalk event tracked:', eventName, enhancedProperties);
    } catch (error) {
      console.error('ChannelTalk event tracking failed:', error);
    }
  }

  // ページ設定（SPA用）
  setPage(page) {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('setPage', page);
      console.log('ChannelTalk page set:', page);
    } catch (error) {
      console.error('ChannelTalk page setting failed:', error);
    }
  }

  // メッセンジャー表示
  showMessenger() {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('showMessenger');
    } catch (error) {
      console.error('ChannelTalk show messenger failed:', error);
    }
  }

  // メッセンジャー非表示
  hideMessenger() {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('hideMessenger');
    } catch (error) {
      console.error('ChannelTalk hide messenger failed:', error);
    }
  }

  // チャットを開く
  openChat(chatId, message) {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('openChat', chatId, message);
    } catch (error) {
      console.error('ChannelTalk open chat failed:', error);
    }
  }

  // シャットダウン
  shutdown() {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('shutdown');
      this.isBooted = false;
      this.currentUser = null;
      console.log('ChannelTalk shutdown');
    } catch (error) {
      console.error('ChannelTalk shutdown failed:', error);
    }
  }

  // コールバック設定
  onShowMessenger(callback) {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('onShowMessenger', callback);
    } catch (error) {
      console.error('ChannelTalk onShowMessenger failed:', error);
    }
  }

  onHideMessenger(callback) {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('onHideMessenger', callback);
    } catch (error) {
      console.error('ChannelTalk onHideMessenger failed:', error);
    }
  }

  onBadgeChanged(callback) {
    try {
      if (!this.isBooted) return;

      window.ChannelIO('onBadgeChanged', callback);
    } catch (error) {
      console.error('ChannelTalk onBadgeChanged failed:', error);
    }
  }

  // 現在の状態を取得
  getStatus() {
    return {
      isInitialized: this.isInitialized,
      isBooted: this.isBooted,
      currentUser: this.currentUser,
    };
  }
}

export default new ChannelTalkService();
